var map = {
	"./de-DE.json": "6922",
	"./el-GR.json": "36de",
	"./en-EN.json": "611e",
	"./es-ES.json": "4109",
	"./fa-IR.json": "6237",
	"./fr-FR.json": "cfe4",
	"./id-ID.json": "7502",
	"./it-IT.json": "bf7d",
	"./ja-JA.json": "04f9",
	"./ko-KR.json": "7692",
	"./my-MY.json": "7568",
	"./pl-PL.json": "ace3",
	"./pt-PT.json": "7b75",
	"./ru-RU.json": "b69a",
	"./th-TH.json": "4e41",
	"./tr-TR.json": "3ba8",
	"./ur-PK.json": "1cd9",
	"./vi-VN.json": "f081",
	"./zh-CN.json": "423e0",
	"./zh-TW.json": "9ea5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";